export enum PageType {
    shop = 'index',
    setting = 'custom',
}

export enum MallType {
    SETTING = 'setting',
    MALL = 'shop',
}
